'use client';

import Image from 'next/image';
import React from 'react';

/* ─── Text logos ─── */
function CrearteLogo() {
  return (
    <div className="flex flex-col items-center">
      <span
        className="text-[20px] sm:text-[24px] font-bold tracking-[0.22em] text-white uppercase"
        style={{ fontFamily: 'Raleway, sans-serif' }}
      >
        Crearte
      </span>
      <span
        className="mt-[3px] text-[8px] sm:text-[9px] font-medium tracking-[0.15em] text-[#8899aa] uppercase"
        style={{ fontFamily: 'Raleway, sans-serif' }}
      >
        Since 2015
      </span>
    </div>
  );
}

function NextLogo() {
  return (
    <div className="flex flex-col items-center">
      <div className="flex items-center gap-[4px]">
        <span
          className="text-[18px] sm:text-[22px] font-bold text-white tracking-tight"
          style={{ fontFamily: 'Raleway, sans-serif' }}
        >
          &#62;&#62;
        </span>
        <span
          className="text-[20px] sm:text-[24px] font-bold tracking-[0.12em] text-white uppercase"
          style={{ fontFamily: 'Raleway, sans-serif' }}
        >
          Next
        </span>
      </div>
      <span
        className="mt-[4px] text-[7px] sm:text-[8px] font-medium tracking-[0.08em] text-[#8899aa] uppercase text-center leading-tight"
        style={{ fontFamily: 'Raleway, sans-serif' }}
      >
        Conectando você de ponta a ponta
      </span>
    </div>
  );
}

function IbfLogo() {
  return (
    <div className="flex items-center gap-[2px]">
      <div className="flex flex-col items-center">
        <div className="w-[16px] h-[16px] sm:w-[20px] sm:h-[20px] rounded-full bg-[#a4c639]" />
        <div className="w-[12px] h-[28px] sm:w-[16px] sm:h-[36px] bg-[#a4c639] rounded-sm mt-[2px]" />
      </div>
      <span
        className="text-[30px] sm:text-[38px] font-bold text-white tracking-tight leading-none ml-[2px]"
        style={{ fontFamily: 'Raleway, sans-serif' }}
      >
        BF
      </span>
    </div>
  );
}

function RomanelliLogo() {
  return (
    <Image
      src="/images/clients/romanelli.png"
      alt="Romanelli"
      width={220}
      height={140}
      className="max-h-[80px] sm:max-h-[100px] lg:max-h-[120px] w-auto object-contain"
    />
  );
}

function TsiLogo() {
  return (
    <div className="flex flex-col items-center">
      <span
        className="text-[26px] sm:text-[30px] font-bold tracking-[0.08em] text-white uppercase"
        style={{ fontFamily: 'Raleway, sans-serif' }}
      >
        TSI
      </span>
      <span
        className="mt-[3px] text-[9px] sm:text-[10px] font-medium tracking-[0.18em] text-[#8899aa] uppercase"
        style={{ fontFamily: 'Raleway, sans-serif' }}
      >
        Terceirizaç<span className="text-white">ã</span>o
      </span>
    </div>
  );
}

/* ─── Image logos ─── */
function MultiquimicaLogo() {
  return (
    <Image
      src="/images/clients/multiquimica.png"
      alt="Multiquímica"
      width={220}
      height={140}
      className="max-h-[80px] sm:max-h-[100px] lg:max-h-[120px] w-auto object-contain"
    />
  );
}

const clients = [
  { name: 'Crearte', Logo: CrearteLogo },
  { name: 'NEXT', Logo: NextLogo },
  { name: 'IBF', Logo: IbfLogo },
  { name: 'Romanelli', Logo: RomanelliLogo },
  { name: 'TSI', Logo: TsiLogo },
  { name: 'Multiquímica', Logo: MultiquimicaLogo },
];

export default function ClientsSection() {
  const doubledClients = [...clients, ...clients];

  return (
    <section className="w-full bg-[#02020c] py-[28px] sm:py-[42px] lg:py-[56px] overflow-hidden relative border-t border-[#ffffff14]">
      <style dangerouslySetInnerHTML={{__html: `
        @keyframes scroll-clients {
          0% { transform: translateX(0); }
          100% { transform: translateX(-100%); }
        }
        .animate-scroll-clients {
          animation: scroll-clients 30s linear infinite;
        }
        .group:hover .animate-scroll-clients {
          animation-play-state: paused;
        }
      `}} />

      <div className="w-full max-w-7xl mx-auto px-4">
        {/* Header */}
        <div className="flex flex-col items-center gap-[10px] mb-[40px] text-center">
          <span
            className="rounded-full border border-[#ffffff1f] bg-[#0d2f3b33] px-[12px] py-[7px] text-[10px] sm:text-[12px] lg:text-[14px] font-medium leading-[12px] sm:leading-[14px] lg:leading-[17px] text-[#d7e8ff]"
            style={{ fontFamily: 'Raleway' }}
          >
            Nosso Portfólio
          </span>

          <h2
            className="mt-[8px] text-[24px] sm:text-[36px] lg:text-[48px] font-semibold leading-[30px] sm:leading-[44px] lg:leading-[58px]"
            style={{ fontFamily: 'Raleway' }}
          >
            <span className="bg-gradient-to-b from-[#f7faff] to-[#9eb5dc] bg-clip-text text-transparent">
              Empresas para quem já desenvolvemos
            </span>
          </h2>

          <p
            className="max-w-[640px] text-[13px] sm:text-[17px] lg:text-[20px] font-normal leading-[19px] sm:leading-[26px] lg:leading-[30px] text-[#b7c3d7]"
            style={{ fontFamily: 'Raleway' }}
          >
            Soluções de IA que entregam resultados reais para empresas.
          </p>

        </div>
      </div>

      {/* Marquee Container */}
      <div className="relative w-full group">
        {/* Gradient Fade Overlays */}
        <div className="absolute inset-y-0 left-0 w-16 sm:w-24 lg:w-32 bg-gradient-to-r from-[#02020c] to-transparent z-10 pointer-events-none" />
        <div className="absolute inset-y-0 right-0 w-16 sm:w-24 lg:w-32 bg-gradient-to-l from-[#02020c] to-transparent z-10 pointer-events-none" />

        {/* Marquee Track */}
        <div className="flex overflow-hidden select-none">
          {/* First Set */}
          <div className="flex shrink-0 gap-[16px] sm:gap-[24px] lg:gap-[32px] w-max animate-scroll-clients pr-[16px] sm:pr-[24px] lg:pr-[32px]">
            {doubledClients.map((client, index) => (
              <div
                key={`c1-${index}`}
                className="flex items-center justify-center rounded-[24px] border border-[#ffffff1a] bg-[linear-gradient(180deg,rgba(255,255,255,0.06)_0%,rgba(255,255,255,0.02)_100%)] px-[24px] sm:px-[32px] lg:px-[40px] py-[32px] sm:py-[40px] lg:py-[48px] w-[200px] sm:w-[240px] lg:w-[280px] shrink-0 transition-all duration-300 hover:border-[#ffffff33] hover:bg-[linear-gradient(180deg,rgba(255,255,255,0.10)_0%,rgba(255,255,255,0.04)_100%)]"
              >
                <div className="opacity-90 transition-opacity duration-300 group-hover:opacity-100">
                  <client.Logo />
                </div>
              </div>
            ))}
          </div>

          {/* Second Set (Duplicate for seamless loop) */}
          <div className="flex shrink-0 gap-[16px] sm:gap-[24px] lg:gap-[32px] w-max animate-scroll-clients pr-[16px] sm:pr-[24px] lg:pr-[32px]" aria-hidden="true">
            {doubledClients.map((client, index) => (
              <div
                key={`c2-${index}`}
                className="flex items-center justify-center rounded-[24px] border border-[#ffffff1a] bg-[linear-gradient(180deg,rgba(255,255,255,0.06)_0%,rgba(255,255,255,0.02)_100%)] px-[24px] sm:px-[32px] lg:px-[40px] py-[32px] sm:py-[40px] lg:py-[48px] w-[200px] sm:w-[240px] lg:w-[280px] shrink-0 transition-all duration-300 hover:border-[#ffffff33] hover:bg-[linear-gradient(180deg,rgba(255,255,255,0.04)_100%)]"
              >
                <div className="opacity-90 transition-opacity duration-300 group-hover:opacity-100">
                  <client.Logo />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
